import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { stats, faqItems } from '@/mocks/articles';

export default function About() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黑料吃瓜网',
    url: 'http://baoliao51.cn/',
    description: '每日更新热门黑料、网红塌房爆料与不打烊吃瓜资源。覆盖91吃瓜、17吃瓜及在线观看内容，一站直达最新大瓜现场。',
    foundingDate: '2024',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@baoliao51.cn',
    },
  };

  const faqPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 黑料吃瓜网',
    url: 'http://baoliao51.cn/about',
    description: '了解黑料吃瓜网的品牌故事、核心优势与联系方式。我们致力于为用户提供最新、最热的娱乐资讯。',
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqPageSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(aboutPageSchema)}</script>

      <Navbar />

      <main className="pt-24 pb-16">
        <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="mb-16">
            <div className="max-w-3xl">
              <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider font-label">
                关于我们
              </span>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mt-3 leading-tight">
                了解黑料吃瓜网
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-5">
                黑料吃瓜网成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为吃瓜群众提供最新、最热、最全的娱乐圈动态。从明星八卦到网红塌房，从综艺内幕到行业爆料，我们以最快的速度、最准的信息，让你不错过每一个精彩瞬间。
              </p>
            </div>
          </section>

          <section className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat, index) => (
                <div
                  key={index}
                  className="bg-background-100 rounded-xl p-6 text-center"
                >
                  <p className="text-3xl md:text-4xl font-heading font-bold text-accent-500">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-600 mt-2">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
              品牌优势
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-100 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-flashlight-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">极速更新</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  24小时不间断追踪娱乐圈动态，重大事件发生后的第一时间进行报道，让你永远走在吃瓜第一线。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                  <i className="ri-shield-check-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">信息可靠</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  所有爆料内容均经过多轮核实，拒绝谣言和虚假信息。我们坚持"有料有真相"的报道原则。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                  <i className="ri-stack-line text-secondary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2">分类齐全</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  六大内容板块覆盖娱乐圈各个维度，从明星到网红、从综艺到内幕，精准分类让吃瓜更高效。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
              联系方式
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                  <p className="text-sm text-foreground-600">hello@baoliao51.cn</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                  <i className="ri-mail-send-line text-accent-500"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">投稿爆料</h3>
                  <p className="text-sm text-foreground-600">hello@baoliao51.cn</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 shrink-0">
                  <i className="ri-customer-service-line text-secondary-500"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服支持</h3>
                  <p className="text-sm text-foreground-600">hello@baoliao51.cn</p>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 shrink-0">
                  <i className="ri-wechat-line text-primary-500"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                  <p className="text-sm text-foreground-600">搜索"黑料吃瓜网"关注我们</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
              常见问题
            </h2>
            <div className="max-w-3xl space-y-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                  <summary className="flex items-center justify-between text-sm font-semibold text-foreground-900 list-none">
                    {item.question}
                    <i className="ri-add-line group-open:rotate-45 transition-transform text-foreground-400"></i>
                  </summary>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
}